import { FC } from 'react';
import { useTranslation } from 'utils/i18n';
import { getWeekdays } from '../../../constants/weekdays';
import useIsMobile from '../../../hooks/useIsMobile';
import { OpeningTimes } from '../../../hooks/useVenue';

interface Props {
  openingTimes: OpeningTimes;
}

const NonClinicalTimes: FC<Props> = ({ openingTimes }) => {
  const { t } = useTranslation('common');
  const isMobileView = useIsMobile();

  // The day names come from the (lowercase) week_days translations, so they
  // line up with the OpeningTimes keys but arrive as plain strings.
  const startTime = (day: string) => {
    return openingTimes[`${day}Start` as keyof OpeningTimes];
  };

  const endTime = (day: string) => {
    return openingTimes[`${day}End` as keyof OpeningTimes];
  };

  const openTimes = (day: string) => {
    const start = startTime(day);
    const end = endTime(day);
    if (start && end && parseInt(end, 10) - parseInt(start, 10) !== 0) {
      return `${start} - ${end}`;
    }
    return t('shared.closed');
  };

  const weekDay = (day: string) => {
    return isMobileView ? day.charAt(0) : day;
  };

  return (
    <tbody>
      {getWeekdays().map(day => {
        return (
          <tr key={day}>
            <td className="booking-times__day">{weekDay(day)}</td>
            <td className="booking-times__hours">{openTimes(day)}</td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default NonClinicalTimes;
